import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../../base/baseUpdate.dto'

@ArgsType()
export class UpdateMessageThreadDto extends BaseUpdateDto<UpdateMessageThreadDto> {
  @Field(t => Int)
  state!: number
}
